<template>

    <div class="rpm-check-list">
        <b-card no-body>
            <table class="table card-table table-striped">
                <thead>
                <tr>
                    <td>{{ $i18n.gt('LABEL_DATE') }}</td>
                    <td>{{ $i18n.gt('LABEL_STATUS') }}</td>
                    <td>{{ $i18n.gt('LABEL_COMMENTS') }}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-if="checks.length == 0">
                    <td class="text-center" colspan="3">{{ $i18n.gt('LABEL_NO_RPM_CHECKS') }}</td>
                </tr>
                <tr v-else v-for="(check, index) in checks" :key="index">
                    <td>{{ check.updated | moment('M/D/YYYY') }}</td>
                    <td>
                        <!-- v-if is needed here to prevent assigning variant to null breaking the component-->
                        <b-badge v-if="check.status" :variant="metricUtil.checkStatusLabels()[check.status].variant">
                            {{ metricUtil.checkStatusLabels()[check.status].label }}
                        </b-badge>
                    </td>
                    <td>
                       <span v-if="check.comment">{{ check.comment }}</span>
                    </td>
                </tr>
                </tbody>
            </table>
        </b-card>
    </div>
</template>

<script>

import MetricUtil from '@/providers/Metrics'

export default {
    name: "RpmCheckList",
    props: {
        checks: Array,
    },
    data() {
        return {
            metricUtil: MetricUtil
        }
    },
}
</script>

<style scoped>

</style>
